// extracted by mini-css-extract-plugin
module.exports = {"header":"_3WnARTWlvPKq4Bn6AOWENf","dialog":"_2tludel0Wuh7rtgvYRc9kn"};